module.exports = "https://cdn-social.hiplatform.com/images/ae482122ecbbf471fc68985d9bb88f75.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/f_logo_RGB-White_1024.png
// module id = pgPb
// module chunks = 0